import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { GENERATE_QR_CODES } from "../qr-code.queries";
import {
  GenerateQrCodesMutation,
  GenerateQrCodesMutationVariables,
} from "../../../__generated__/GenerateQrCodesMutation";

export const useGenerateQrCodes = () => {
  const [mutate, { loading }] = useMutation<
    GenerateQrCodesMutation,
    GenerateQrCodesMutationVariables
  >(GENERATE_QR_CODES, {
    refetchQueries: "active",
  });

  const generate = async (count: number) => {
    try {
      const { data } = await mutate({ variables: { count } });
      if (!data?.generateQrCodes?.ok) {
        throw Error(data?.generateQrCodes?.error ?? "Error");
      }
      return data.generateQrCodes.results ?? [];
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
      return null;
    }
  };

  return { generate, loading };
};
